export enum ForceRestoreRequestBy {
	User,
	EventOutcomeAction
}

export interface ForceRestoreRequest {
	id: number;
	reason: string;
	requestBy?: ForceRestoreRequestBy
}